<!--manage-customers works!-->
<h3>Manage Customer</h3>
<div id="topmost">
  <div id="blockingScreen" [appBlockingScreen]="enableBlockingScreen" ></div>
  <div id="customer-list-pane">
    <div id="customer-grid">
      <kendo-grid [data]="gridView"
        [kendoGridSelectBy]="'CustomerID'"
        [selectedKeys]="anotherCustID"
        (selectionChange)="customerSelection($event)"
        [selectable]="true"
        [sortable]="{allowUnsort: true,mode:'single'} "
        [sort]="sort" (sortChange)="sortChange($event)">
        <kendo-grid-column field="CustomerID" title="ID" [width]="60">
        </kendo-grid-column>
        <kendo-grid-column field="Name" title="Customer" [width]="190">
        </kendo-grid-column>
        <kendo-grid-column field="UserCount" title="User Count" [width]="100">
        </kendo-grid-column>
      </kendo-grid>
    </div>
    <div>
      <button class="k-button cvt-primary" (click)="editCustomer()">Edit Customer</button>
      <button class="k-button cvt-secondary" (click)="addCustomer()">Add Customer</button>
    </div>
  </div>
  <div>
    <router-outlet></router-outlet>
  </div>

</div>
